import { Trans } from 'next-i18next';

import styles from './counts-about.module.css';

const CountsAbout = ({ items }) => {
  if (!items) return null;

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <img src="/images/rodo-logo-fix.svg" alt="" width={140} height={50} />
        <div className={styles.titleText}>
          <Trans
            i18nKey="forma_project_of_traectoria"
            components={{
              accent: <span className={styles.accent} />
            }}
          />
        </div>
      </div>
      <div className={styles.content}>
        {items.map(({ count, title }, index) => (
          <div className={styles.item} key={index}>
            <div className={styles.count}>{count}</div>
            <div className={styles.description}>{title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountsAbout;
